import { render, staticRenderFns } from "./itemFilterModal.vue?vue&type=template&id=6b1a8b9c&"
import script from "./itemFilterModal.vue?vue&type=script&lang=ts&"
export * from "./itemFilterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports